import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { IAppConfig } from '../shared/interfaces/app-config';
import { AppConfigService } from './app-config.service';
import { GeoClientResponse } from '../shared/interfaces/goat-address';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  getGOATAddress(
    borough: string,
    streetNumber: string,
    streetName: string
  ): Observable<GeoClientResponse> {
    const httpOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        accept: '*/*',
      }),
    };
    const searchObj: {
      borough: string;
      addressNumber: string;
      streetName: string;
    } = {
      borough: borough,
      addressNumber: streetNumber,
      streetName: streetName,
    };
    return this.http
      .post<GeoClientResponse>(
        `${this.config.apiUrl}/GOAT/getAddress`,
        searchObj,
        httpOptions
      )
      .pipe(catchError(this.handleError));
  }

  // Error handling
  handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage: string = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return new Error(errorMessage);
    });
  }
}
